"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpaceWrapper = exports.LabelWrapper = exports.ManouverWrapper = exports.CounterWrapper = exports.LabelColumn = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__Wrapper",
  componentId: "k780lb-0"
})(["width:100%;height:80px;display:flex;flex-direction:row;background:#3d4a69;justify-content:space-between;padding:0.1rem 0;"]);

exports.Wrapper = Wrapper;

var LabelColumn = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__LabelColumn",
  componentId: "k780lb-1"
})(["display:flex;flex-direction:row;width:15%;"]);

exports.LabelColumn = LabelColumn;

var CounterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__CounterWrapper",
  componentId: "k780lb-2"
})(["display:flex;flex-direction:row;align-items:flex-start;justify-content:center;padding-top:1rem;font-weight:bold;color:white;width:20%;"]);

exports.CounterWrapper = CounterWrapper;

var ManouverWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__ManouverWrapper",
  componentId: "k780lb-3"
})(["display:flex;flex-direction:row;padding-bottom:0.2rem;"]);

exports.ManouverWrapper = ManouverWrapper;

var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__LabelWrapper",
  componentId: "k780lb-4"
})(["width:100%;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"]);

exports.LabelWrapper = LabelWrapper;

var SpaceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesRowStyles__SpaceWrapper",
  componentId: "k780lb-5"
})(["height:100%;min-width:2000px;display:flex;flex-direction:row;justify-content:flex-start;"]);

exports.SpaceWrapper = SpaceWrapper;